import React from "react";

function Vision() {
  return (
    <div className="s-vision">
      <span>Our Vision</span>
      <div className="content">
        <p className="main">
          Backed by a team of skilled engineers and designers, we offer a wide
          range of services, from innovative product design and development to
          fabrication and manufacturing specializing in electric vehicles and
          user-centered software solutions. Our expertise extends beyond the
          workshop, as we provide tailored software solutions for website
          creation and brand development, ensuring your business stands out in
          the digital realm. 
        </p>
        <p>
          Join us in shaping the future of engineering and websites with
          seamless integration and unparalleled expertise.
        </p>
      </div>
    </div>
  );
}

export default Vision;
